/* eslint react/no-unused-prop-types: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from './input';

class TextInput extends Component {

    static propTypes = {
        label: PropTypes.string,
        name: PropTypes.string,
        placeholder: PropTypes.string,
        tooltipText: PropTypes.string,
        errorText: PropTypes.string,
        value: PropTypes.string,
        onChange: PropTypes.func
    };

    render() {
        return <Input {...this.props} type="text" />;
    }

}

export default TextInput;
